import PropTypes from 'prop-types';
import React from 'react';
import { useToggle } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    IconButton
} from 'mol-ui';
import {
    Container,
    Filters
} from './styled';

const FilterPanel = ({
    active: activeProp,
    children,
    defaultActive,
    loading,
    onApply,
    onClear,
    onToggle = () => null
}) => {

    const [active, toggleActive] = useToggle(defaultActive);
    const { t } = useTranslation();

    const handleClear = () => {
        onClear();
        handleToggle();
    };
    
    const handleToggle = () => {
        onToggle();
        toggleActive();
    };

    const isActive = activeProp ?? active;

    return (
        <Container>
            <Filters hidden={ !isActive }>
                { children }
            </Filters>
            {
                isActive && (onApply || onClear) &&
                <ButtonFooter margin="0px 0px 10px 0px">
                    {
                        onClear &&
                        <ExpandButton
                            danger
                            caption={ t('Limpiar') }
                            disabled={ loading }
                            size={ 80 }
                            onClick={ handleClear }
                        />
                    }
                    {
                        onApply &&
                        <ExpandButton
                            caption={ t('Aplicar') }
                            loading={ loading }
                            size={ 80 }
                            onClick={ onApply }
                        />
                    }
                </ButtonFooter>
            }
            <IconButton
                icon={ isActive ? 'expand_less' : 'expand_more' }
                label={ isActive ? t('Ocultar filtros') : t('Ver más filtros') }
                margin={ isActive ? '10px 0px 0px 0px' : '0px' }
                size={ 16 }
                onClick={ handleToggle }
            />
        </Container>
    );
};

FilterPanel.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.any,
    defaultActive: PropTypes.bool,
    loading: PropTypes.bool,
    onApply: PropTypes.func,
    onClear: PropTypes.func,
    onToggle: PropTypes.func
};

export default FilterPanel;
